import useAccount from "@hooks/useAccount";
import useMediaQuery from "@hooks/useMediaQuery";
import { useUnstoppableDomain } from "@hooks/useUnstoppableDomain";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import { Breadcrumbs, Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { CustomConnectButton } from "@utils/connectButton";
import { useRouter } from "next/router";
import LanguageMenu from "./LanguageMenu";
import TokenMenu from "./TokenMenu";

export default function Header({
	handleDrawerOpen = () => null,
	open = false,
	showMenu = false,
}) {
	const { pathname } = useRouter();
	const { isMobile } = useMediaQuery();
	const { account, isConnected } = useAccount();
	const UDID = useUnstoppableDomain(account, isConnected);
	return (
		<AppBar
			color="transparent"
			position="sticky"
			elevation={0}
			sx={{
				alignItems: "center",
				display: "flex",
				flexDirection: "row",
				justifyContent: "space-between",
				paddingX: 4,
				paddingY: 2,
				zIndex: 19,
			}}
		>
			<Breadcrumbs aria-label="breadcrumb" sx={{ minWidth: "30%" }}>
				<Typography
					textTransform="capitalize"
					color="text.primary"
					fontWeight={600}
					fontSize={isMobile ? 2 : 15}
					sx={{ cursor: "pointer" }}
				>
					{pathname?.replace("/", "") ?? "Home"}
				</Typography>
			</Breadcrumbs>
			{showMenu ? (
				<IconButton
					color="inherit"
					aria-label="open drawer"
					onClick={handleDrawerOpen}
					edge="start"
					sx={{ left: 24, mr: 0, position: "absolute" }}
				>
					{open ? <CloseIcon /> : <MenuIcon />}
				</IconButton>
			) : null}
			<Toolbar sx={{ paddingRight: isMobile ? "0 !important" : "unset" }}>
				<LanguageMenu />
				<TokenMenu />
				<Box display="flex" gap={2}>
					{!UDID && (
						<ConnectButton
							accountStatus={{
								largeScreen: "address",
								smallScreen: "address",
							}}
							showBalance={{
								largeScreen: true,
								smallScreen: false,
							}}
						/>
					)}
					{UDID && <CustomConnectButton UnstoppableDomain={UDID} />}
				</Box>
			</Toolbar>
		</AppBar>
	);
}
